var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { sub, startOfDay, startOfYesterday, endOfYesterday, endOfWeek, startOfWeek, subWeeks, startOfMonth, endOfMonth, isSameDay, subMonths, min, } from 'date-fns';
var startOf = startOfDay(new Date());
export var getStaticRanges = function (disableFutureDates) {
    if (disableFutureDates === void 0) { disableFutureDates = false; }
    return [
        {
            label: 'Yesterday',
            range: function () { return ({
                startDate: startOfYesterday(),
                endDate: startOfDay(endOfYesterday())
            }); }
        },
        {
            label: 'Last 7 days',
            range: function () { return ({
                startDate: sub(startOf, { days: 7 }),
                endDate: startOfDay(endOfYesterday())
            }); }
        },
        {
            label: 'Last 14 days',
            range: function () { return ({
                startDate: sub(startOf, { days: 14 }),
                endDate: startOfDay(endOfYesterday())
            }); }
        },
        {
            label: 'Last 30 days',
            range: function () { return ({
                startDate: sub(startOf, { days: 30 }),
                endDate: startOfDay(endOfYesterday())
            }); }
        },
        {
            label: 'Last 90 days',
            range: function () { return ({
                startDate: sub(startOf, { days: 90 }),
                endDate: startOfDay(endOfYesterday())
            }); }
        },
        {
            label: 'This week',
            range: function () { return ({
                startDate: startOfWeek(startOf, { weekStartsOn: 0 }),
                endDate: disableFutureDates
                    ? startOfDay(min([endOfWeek(startOf, { weekStartsOn: 0 }), startOf]))
                    : startOfDay(endOfWeek(startOf, { weekStartsOn: 0 }))
            }); }
        },
        {
            label: 'Last week',
            range: function () { return ({
                startDate: startOfWeek(subWeeks(startOf, 1), { weekStartsOn: 0 }),
                endDate: startOfDay(endOfWeek(subWeeks(startOf, 1), { weekStartsOn: 0 }))
            }); }
        },
        {
            label: 'This month',
            range: function () { return ({
                startDate: startOfMonth(startOf),
                endDate: disableFutureDates ? startOfDay(min([endOfMonth(startOf), startOf])) : startOfDay(endOfMonth(startOf))
            }); }
        },
        {
            label: 'Last month',
            range: function () { return ({
                startDate: startOfMonth(subMonths(startOf, 1)),
                endDate: startOfDay(endOfMonth(subMonths(startOf, 1)))
            }); }
        },
    ].map(function (mapRange) { return (__assign(__assign({}, mapRange), { hasCustomRendering: true, isSelected: function (range) {
            var _a, _b, _c, _d;
            var isSameDayStartDate = isSameDay(new Date((_a = mapRange.range().startDate) !== null && _a !== void 0 ? _a : 0), new Date((_b = range.startDate) !== null && _b !== void 0 ? _b : 0));
            var isSameDayEndDate = isSameDay(new Date((_c = mapRange.range().endDate) !== null && _c !== void 0 ? _c : 0), new Date((_d = range.endDate) !== null && _d !== void 0 ? _d : 0));
            return isSameDayEndDate && isSameDayStartDate;
        } })); });
};
